import { Component, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SortIconComponent } from '../../../../core/components/sort-icon/sort-icon.component';
import { environment } from '../../../../../../environments/environment';
import { TableDataService } from './table-data';
import { SortState } from '../../../../core/models/sort.model';
import { DatePipe } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-announcements',
  standalone: true,
  imports: [TableModule, SvgIconComponent],
  templateUrl: './announcements.component.html',
  styleUrl: './announcements.component.scss',
  providers: [DatePipe]
})
export class AnnouncementsComponent implements OnInit {
  defaultAvatar = environment.defaultAvatar;
  profileImageUrl = environment.defaultAvatar;


  tableData: any = []; // data source
  loading: boolean = true;
  sorting!: SortState;
  cols!: any[];


  constructor(
    private tableDataService: TableDataService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getTableData()

    this.cols = [
      { field: 'Title', header: 'Title', sortable: true },
      { field: 'PostedDate', header: 'Posted Date', sortable: true },
    ];

    this.sorting = {
      column: 'PostedDate',
      direction: 'desc'
    }
  }

  getTableData(): void {
    this.loading = false;

    // this.tableDataService.getTable().then((data) => {
    //   this.tableData = data;
    //   this.loading = false;
    // });
  }

  formatDate(date: any): string {
    const dateObj = new Date(date);
    const datePart = this.datePipe.transform(dateObj, 'MMM d, y') || '';
    const timePart = this.datePipe.transform(dateObj, 'h:mm a') || '';
    return `${datePart}, at ${timePart}`;
  }

}
